import { CoGs, FixedCutterPreBOMInput, Powder, Productline } from '../../interfaces/request'
import { IORD_Order, IPatchOrderTaskDto, PatchORDArmDto, PatchORDBitDto, PatchORDCerebroDto, PatchORDCutterMapDto, PatchOrderCommunictionDto, PatchOrderTaskDto, PatchORDGaugeProtectionDto, PatchORDOrderDto, PatchORDOrderOnHoldDto, PatchORDPowderDto, PatchORDUppersectionDto, PatchPartElementDto, PatchRollerConeDto, TaskViewModel } from '../../interfaces/request.interface'

export namespace RequestActions {
  export class CreateRequest {
    static readonly type = '[Request] Request Create'
    constructor(public payload: { request: Partial<PatchORDOrderDto>, userId: number }) { }
  }

  export class GetRequestDetails {
    static readonly type = '[Request] Request Get'
    constructor(public payload: { id: string }) { }
  }

  export class UpdateRequest {
    static readonly type = '[Request] Request Update'
    constructor(public payload: { request: Partial<PatchORDOrderDto>, userId: number, key: number }) { }
  }

  export class DeleteRequest {
    static readonly type = '[Request] Request Delete'
    constructor(public payload: { id: number }) { }
  }

  export class ListRequest {
    static readonly type = '[Request] Request List'
  }

  export class PatchRequestDraft {
    static readonly type = '[Request] Patch Draft';
    constructor(
      public payload: {
        draftId?: number;
        changes: Partial<PatchORDOrderDto> & {
          bit?: PatchORDBitDto;
          cerebro?: PatchORDCerebroDto;
          cutterMaps?: PatchORDCutterMapDto[];
          orderTasks?: PatchOrderTaskDto[];
          uppersection?: PatchORDUppersectionDto;
          gaugeProtections?: PatchORDGaugeProtectionDto[];
          powders?: PatchORDPowderDto[];
          fixedCutterSapData?: FixedCutterPreBOMInput;
          bitFeatureIds?: number[];
          arm?: PatchORDArmDto;
          rollerCone?: PatchRollerConeDto;
        };
      }
    ) { }
  }
  export class PatchRequest {
    static readonly type = '[Request] Patch Request';
    constructor(public request: Partial<IORD_Order>) {}
  }
  export class SaveDraft {
    static readonly type = '[Request] Save Draft';
    constructor(public payload: { draftId: number | undefined, userId: number }) { }
  }
  export class UpsertOrderBit {
    static readonly type = '[Request] Upsert Order Bit';
    constructor(public payload: {
      bit: PatchORDBitDto;
      userId: number;
      key: number;
    }) { }
  }

  export class UpsertOrderCerebro {
    static readonly type = '[Request] Upsert Order Cerebro';
    constructor(public payload: {
      cerebro: PatchORDCerebroDto;
      userId: number;
      key: number;
    }) { }
  }

  export class UpdateOrderCutterMap {
    static readonly type = '[Request] Update Cutter Map';
    constructor(public payload: {
      cutterMap: PatchORDCutterMapDto[];  // ← array of cutter‐map DTOs
      userId: number;
      key: number;
    }) { }
  }

  export class UpdateOrderTask {
    static readonly type = '[Request] Update Order Task';
    constructor(public payload: {
      task: IPatchOrderTaskDto;
      key: number;
    }) { }
  }

  export class UpdateOrderGauge {
    static readonly type = '[Request] Update Gauge Protection';
    constructor(public payload: {
      gauge: PatchORDGaugeProtectionDto[];
      userId: number;
      key: number;
    }) { }
  }
  export class UpdateOrderPowderBinder {
    static readonly type = '[Request] Update Powder Binder';
    constructor(public payload: {
      powder: PatchORDPowderDto[];
      userId: number;
      key: number;
    }) { }
  }
  export class UpsertOrderArm {
    static readonly type = '[Request] Upsert Order Arm';
    constructor(public payload: {
      arm: PatchORDArmDto;
      userId: number;
      key: number;
    }) { }
  }
  export class UpsertRollerCone {
    static readonly type = '[Request] Upsert Roller Cone';
    constructor(public payload: {
      rollerCone: PatchRollerConeDto;
      userId: number;
      key: number;
    }) { }
  }
  export class GetCutterMappingDeatils {
    static readonly type = '[Request] Get Cutter Mapping Details';
    constructor(public payload: { id: number }) { }
  }

  export class PostCommunication {
    static readonly type = '[Request] Post Communication'
    constructor(public payload: { 
      communication: PatchOrderCommunictionDto;
      key: number;
     }) { }
  }

  export class LoadCoGs {
    static readonly type = '[Request] Load CoGs';
    constructor(public orderId: number) {}
  }
  
  export class SetCoGs {
    static readonly type = '[Request] Set CoGs';
    constructor(public cogs: CoGs) {}
  }
  export class LoadTasks {
    static readonly type = '[Task] Load Tasks';
    constructor(public orderId: number) {}
  }
  
  export class UpdateTask {
    static readonly type = '[Task] Update Task';
    constructor(
      public taskId: number,
      public payload: {
        user_Id?: number;
        startDate?: Date;
        completeDate?: Date;
        notes?: string;
      }
    ) {}
  }
  export class StartTask {
    static readonly type = '[Task] Start Task';
    constructor(public key: number, public orderId: number) {}
  }
  export class CompleteTask {
    static readonly type = '[Task] Complete Task';
    constructor(public key: number, public notes: string, public orderId: number) {}
  }
  export class RollbackOrderTask {
    static readonly type = '[Task] Rollback Task';
    constructor(public key: number, public orderId: number) {}
  }
  export class RollbackSubOrderTask {
    static readonly type = '[Task] Rollback Sub Task';
    constructor(public key: number, public orderId: number) {}
  }
  export class ApproveOrderTask {
    static readonly type = '[Task] Approve Order Task';
    constructor(public key: number, public orderId: number) {}
  }
  export class RejectOrderTask {
    static readonly type = '[Task] Reject Order Task';
    constructor(public key: number, public reason: string, public orderId: number) {}
  }
  export class ProcessRework {
    static readonly type = '[Task] Process Rework';
    constructor(public key: number, public reworkProcesses: number[]) {}
  }
  export class ProcessOnHold {
    static readonly type = '[Task] Process On Hold';
    constructor(public key: number, public patchonholdDto: PatchORDOrderOnHoldDto) {}
  }
  export class RemoveHold {
    static readonly type = '[Task] Remove Hold';
    constructor(public key: number) {}
  }
  export class AddNewTask {
    static readonly type = '[Task] Add New Task';
    constructor(public taskTemplate: number, public orderId: number, public startQueue: boolean = true) {}
  }
  export class DeleteOrderTask {
    static readonly type = '[Task] Delete Order Task';
    constructor(public taskId: number, public orderId: number) {}
  }
  export class DeleteOrderProcess {
    static readonly type = '[Task] Delete Order Process';
    constructor(public taskId: number, public orderId: number) {}
  }
  export class GetFixedCutterPreBOM {
    static readonly type = '[Request] Get Fixed Cutter Pre BOM';
    constructor(public payload: { id: number }) {}
  }

  export class SubmitRequest {
    static readonly type = '[Request] Submit Request';
    constructor(public payload: { orderId: number; userId: number }) {}
  }

  export class SubmitRequestSuccess {
    static readonly type = '[Request] Submit Request Success';
    constructor(public payload: { orderId: number }) {}
  }

  export class SubmitRequestFailure {
    static readonly type = '[Request] Submit Request Failure';
    constructor(public payload: { orderId: number; error: string }) {}
  }
}
